import { Cache } from './main.js'


const sig = (str) => {
	let hash = 0
	for (let i = 0; i < str.length; i++) {
		hash = (hash << 5) - hash + str.charCodeAt(i)
	}
	return hash.toString(16).slice(1)
}

export class LogCache extends Cache {
    static size = 500
    
    constructor() {
    	super('log-cache', {
    		expiry: 1000 * 60 * 60 * 3, // 3 hours
    	}, 'uid', (item) => `${new Date().getTime()}_${item.type}_${sig(item.message)}`)
    }

    async clean() {
    	let i = 0
    	await Cache.idb.each(this.store, (cursor) => {
    		if (i >= LogCache.size 
                || cursor.value.timestamp + this.settings.expiry < new Date().getTime()
    		) {
    			cursor.delete()
    		} else {
    			i++
    		}
    	}, true)
    }
}